import { AxiosResponse } from "axios";
import { useQuery } from "react-query";
import apiClient from "../apiClient/apiClient";
import { ApiVersion } from "./navigation.types";
import { showToast } from "../../components/Toast/Toast";
import { ToastTypes } from "../../components/Toast/Toast.types";

export const useApiVersion = (refetchCount: number, setRefetchCount: any) => {
    return useQuery<AxiosResponse<ApiVersion>>({
        queryKey: ['apiVersion'],
        queryFn: () => apiClient.get<ApiVersion>('/actuator/info'),
        enabled: true,
        cacheTime: 0,
        refetchInterval: () => {
            if(refetchCount > 3) {
                return false
            }
            return 2400000;
        },
        onSuccess: () => {
            if(refetchCount !== 0){
                showToast({
                    label: 'Session has been extended',
                    id: 'sessionExtended',
                    toastType: ToastTypes.Info,
                })
            }
            setRefetchCount((prevState: number) => prevState + 1);
        },
        refetchIntervalInBackground: true,
    });
};